import styled from 'styled-components';

interface StyledProps {
  hasList?: boolean;
}

export const Container = styled.div.attrs<any, StyledProps>((): any => ({}))`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ hasList }) => (hasList ? 116 : 0)}px;

  @media ${({ theme }) => theme.device.desktop} {
    margin-bottom: ${({ hasList }) => (hasList ? 75 : 0)}px;
  }
`;

export const List = styled.ol`
  display: flex;

  @media ${({ theme }) => theme.device.mobile} {
    flex-direction: column;
    align-items: center;
  }

  @media ${({ theme }) => theme.device.desktop} {
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
`;
